import React, { createRef } from 'react';
import { scrollIntoView } from 'seamless-scroll-polyfill';
import NewAddress from './delivery_address_new_address';
import AddressBook from './delivery_address_address_book';
import DeliverToBranch from './delivery_address_branch_list';
import ChooseDeliveryAddress from './delivery_address_choose_address';
import ManualAddressForm from './manual_address_form';

class DeliveryAddress extends React.Component {
  constructor(props) {
    super(props);
    this.addressRef = createRef();
    this.deliveryScrollRef = createRef();
    this.errorRef = createRef();
    this.state = {
      addresses: [],
      name: this.props.name,
      loading: false,
      search_postcode: '',
      search_postcode_error: false,
      signedInpostcodeError: false,
      selectedAddress: {
        name: '',
        line_1: '',
        line_2: '',
        line_3: '',
        line_4: '',
        line_5: '',
        postcode: '',
      },
      selected: null,
      nameEmpty: false,
      telephone:
        this.props.account.telephone || this.props.guestTelephone || '',
      showTelephoneError: false,
      guestAddressMode: '',
      showManualAddressForm: false,
      showManualAddressButton: false,
      postcodeErrorMessage: 'No Addresses found for postcode',
      postcodeExcluded: false,
    };
    this.editThisStep = this.editThisStep.bind(this);
    this.getAddressesFromPostCode = this.getAddressesFromPostCode.bind(this);
    this.handleGuestDeliveryAddress =
      this.handleGuestDeliveryAddress.bind(this);
    this.handleGuestContactNumber = this.handleGuestContactNumber.bind(this);
    this.handleGuestName = this.handleGuestName.bind(this);

    this.handleSearchPostCodeChange =
      this.handleSearchPostCodeChange.bind(this);
    this.setCurrentStep = this.setCurrentStep.bind(this);
    this.setGuestDeliveryAddress = this.setGuestDeliveryAddress.bind(this);
    this.setAddressModeRemoveAddresses =
      this.setAddressModeRemoveAddresses.bind(this);

    this.valid_postcode = this.valid_postcode.bind(this);
    this.handleTelephoneError = this.handleTelephoneError.bind(this);
    this.handleSignedInpostcodeError =
      this.handleSignedInpostcodeError.bind(this);
    this.globalHandleInputChange = this.globalHandleInputChange.bind(this);
    this.checkTelephoneNumber = this.checkTelephoneNumber.bind(this);
  }

  setGuestDeliveryAddress(address) {
    let formatted_address = {
      name: `${this.state.name}`,
      line_1: address['line_1'],
      line_2: address['line_2'],
      line_3: address['line_3'],
      line_4: address['line_4'],
      line_5: address['line_5'],
      postcode: address['postcode'],
    };
    this.setState(
      {
        selected: address,
        selectedAddress: formatted_address,
        showManualAddressForm: true,
      },
      () => this.validateNewAddressInput(),
    );
  }

  handleGuestDeliveryAddress() {
    if (!this.state.telephone.length) {
      this.handleTelephoneError(true);
      return false;
    }

    this.props.setDeliveryAddress(this.state.selectedAddress);
    this.props.setGuestTelephone(this.state.telephone);
  }

  handleGuestContactNumber(e) {
    this.setState(
      {
        telephone: e.target.value,
        showTelephoneError: false,
      },
      () => {
        this.props.setGuestTelephone(this.state.telephone);
      },
    );
  }

  handleGuestName(e) {
    this.setState({
      name: e.target.value,
    });
  }

  setCurrentStep() {
    const { setCurrentStep } = this.props;
    setCurrentStep('DELIVERY_DETAILS');
  }

  editThisStep() {
    this.props.clearDeliveryService();
    this.props.setCurrentStep('DELIVERY_ADDRESS');
  }

  setAddressModeRemoveAddresses() {
    this.setState(
      { addresses: [], showManualAddressForm: false, selected: null },
      () => {
        this.props.setAddressMode('BRANCH_DELIVERY');
      },
    );
  }

  getAddressesFromPostCode() {
    this.setState({
      search_postcode_error: false,
      addresses: [],
      loading: true,
      showManualAddressForm: false,
      selected: null,
    });
    this.setState({ search_postcode_error: false }, () => {
      $.ajax({
        url: this.props.addressEnquiryUrl,
        method: 'GET',
        dataType: 'json',
        data: {
          postcode: this.state.search_postcode,
        },
        success: data => {
          this.setState({
            addresses: data,
            loading: false,
            showManualAddressButton: true,
            postcodeExcluded: false,
          });
          this.scrollElementIntoView(this.addressRef);
        },
        error: ({ responseText }) => {
          const postcodeErrorMessage = JSON.parse(responseText).message;
          const postcodeExcluded = JSON.parse(responseText).postcode_excluded;
          this.setState({
            search_postcode_error: true,
            postcodeErrorMessage,
            postcodeExcluded: postcodeExcluded ? true : false,
            loading: false,
            addresses: [],
            guestAddressMode: 'NEW_ADDRESS',
            showManualAddressButton: false,
          });
          this.scrollElementIntoView(this.addressRef);
        },
      });
    });
  }

  handleSearchPostCodeChange(e) {
    this.setState({
      search_postcode: e.target.value,
    });
    this.valid_postcode(e.target.value).isValid === true
      ? this.setState({ postcode_valid: true })
      : this.setState({ postcode_valid: false });
  }

  valid_postcode(postcode) {
    try {
      const format = postcode
        .toUpperCase()
        .match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
      const finalValue = `${format[1]} ${format[2]}`;
      const regex =
        /^([a-z]{1,2}[0-9]{1,2}|[a-z]{1,2}[0-9][a-z]) ?\d[ABD-HJLNP-UW-Z]{2}$/i;

      return {
        isValid: regex.test(postcode),
        formatedPostCode: finalValue,
        error: false,
        info: 'It is a valid postcode',
      };
    } catch (error) {
      return { error: true, info: 'Invalid post code has been entered!' };
    }
  }

  handleTelephoneError(value) {
    this.setState({
      showTelephoneError: value,
    });
  }

  handleSignedInpostcodeError(val) {
    this.setState({ signedInpostcodeError: val });
  }

  globalHandleInputChange(e) {
    let newAddress = this.state.selectedAddress;
    const value = e.target.value;
    const name = e.target.name;

    newAddress[name] = value;
    this.setState(
      {
        selectedAddress: newAddress,
      },
      () => this.validateNewAddressInput(),
    );
  }

  validateNewAddressInput() {
    if (
      !this.state.nameEmpty &&
      this.state.selectedAddress.line_1 !== '' &&
      this.state.selectedAddress.line_3 !== '' &&
      this.valid_postcode(this.state.selectedAddress.postcode).isValid === true
    ) {
      this.setState({
        newAddressValid: true,
        selected: this.state.selectedAddress,
      });
      this.scrollElementIntoView(this.deliveryScrollRef);
    } else {
      this.setState({ newAddressValid: false, selected: null });
    }
  }

  checkTelephoneNumber() {
    if (!this.state.telephone.length) {
      this.handleTelephoneError(true);
      return false;
    }
    this.getAddressesFromPostCode();
  }

  scrollElementIntoView(element) {
    scrollIntoView(element.current, {
      behavior: 'smooth',
    });
  }

  componentDidUpdate() {
    this.state.showTelephoneError
      ? this.scrollElementIntoView(this.errorRef)
      : null;
  }

  render() {
    const { postcodeErrorMessage, postcodeExcluded } = this.state;

    var nextStep = (
      <button
        onClick={this.setCurrentStep}
        className="set-address-button next-panel"
        data-testid={
          this.props.signed_in === false
            ? 'guest-delivery-options'
            : 'account-delivery-options'
        }
        disabled={
          this.props.signed_in === false
            ? !this.state.addresses.length
            : !this.props.selectedDeliveryAddress
        }>
        Continue to Delivery Options
      </button>
    );
    var editStep =
      this.props.current_step !== 'DELIVERY_ADDRESS' ? (
        <strong className="edit" onClick={this.editThisStep}>
          Edit
        </strong>
      ) : (
        ''
      );

    var completedStep =
      this.props.current_step !== 'DELIVERY_ADDRESS' ? (
        <i className="icon-ok" />
      ) : (
        ''
      );
    var choose = (
      <ChooseDeliveryAddress
        invoiceAddress={this.props.invoiceAddress}
        addressMode={this.props.addressMode}
        setAddressMode={this.props.setAddressMode}
        account={this.props.account}
        signed_in={this.props.signed_in}
        setAddressModeRemoveAddresses={this.setAddressModeRemoveAddresses}
        setInvoiceAddressAsDeliveryAddress={
          this.props.setInvoiceAddressAsDeliveryAddress
        }
      />
    );
    var loading = this.state.loading === true && (
      <span className="loading">
        <i className="icon-spinner icon-spin icon-large" />
      </span>
    );

    const postcodeSearchError = this.state.search_postcode_error === true && (
      <div>
        <span className="search-postcode--error">{postcodeErrorMessage}</span>
        {!postcodeExcluded && (
          <NewAddress
            addressMode={this.state.guestAddressMode}
            addressEnquiryUrl={this.props.addressEnquiryUrl}
            deliveryAddressUrl={this.props.deliveryAddressUrl}
            getAddressBook={this.props.getAddressBook}
            setAddressFromAddressBook={this.props.setAddressFromAddressBook}
            setAddressMode={this.props.setAddressMode}
            guestPostcodeError={this.state.search_postcode_error}
            signed_in={this.props.signed_in}
            method={'PUT'}
            configGenericError={this.props.configGenericError}
            toggleGenericError={this.props.toggleGenericError}
            showManualAddressForm={this.state.search_postcode_error}
            handleTelephoneError={this.handleTelephoneError}
            telephone={this.state.telephone}
          />
        )}
      </div>
    );

    return (
      // Extract out into seperate component
      <div
        className={
          'checkout-panel delivery-address-step ' +
          (this.props.current_step !== 'DELIVERY_ADDRESS' ? 'not-active' : '') +
          (this.props.processingState === true ? ' processing-payment' : '')
        }>
        <div className="checkout-header-title">
          <div className="checkout-header-title-left">
            <strong>{this.props.step}.</strong> Delivery Address {completedStep}
          </div>
          <div className="checkout-header-title-right">{editStep}</div>
        </div>

        {this.props.signed_in === false && (
          <div className="checkout-sub-panel guest-address find-address">
            <h2>Contact Details</h2>
            <div className="fl-on fl-fd-col">
              <div className="mw-50">
                <label htmlFor="guest-name">
                  Name <strong className="required">*</strong>
                </label>
                <input
                  type="text"
                  id="guest-name"
                  value={this.state.name}
                  autoComplete="off"
                  onChange={this.handleGuestName}
                />
              </div>
              <div className="mw-50 mt-10">
                <label ref={this.errorRef} htmlFor="guest-telephone">
                  Contact Number <strong className="required">*</strong>
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  id="guest-telephone"
                  onChange={this.handleGuestContactNumber}
                />
                {this.state.showTelephoneError && (
                  <p>
                    <span className="search-postcode--error">
                      Please enter a telephone number
                    </span>
                  </p>
                )}
              </div>
            </div>

            <div>
              <h2>Delivery Address</h2>
              {choose}
              <DeliverToBranch
                branchAddress={this.props.branchAddress}
                addresses={this.props.branches}
                showBranchPanel={this.props.showBranchPanel}
                showNoBranches={this.props.showNoBranches}
                addressMode={this.props.addressMode}
                getBranches={this.props.getBranches}
                setAddressFromAddressBook={this.props.setAddressFromAddressBook}
                selectedDeliveryAddress={this.props.selectedDeliveryAddress}
                guestEmail={this.props.guestEmail}
                guestTelephone={this.props.guestTelephone}
                setBranchAddressFlag={this.props.setBranchAddressFlag}
                valid_postcode={this.valid_postcode}
                signed_in={this.props.signed_in}
                handleTelephoneError={this.handleTelephoneError}
              />

              {!this.props.showBranchPanel && (
                <div className="input-address">
                  <div className="manual-address-wrapper">
                    <div ref={this.addressRef} className="fl-fb-50">
                      <label htmlFor="guest-postcode-search">
                        Postcode <strong className="required">*</strong>
                      </label>
                      <div className="fl fw-w ai-c">
                        <input
                          type="text"
                          id="guest-postcode-search"
                          className="postcode guest-postcode-search"
                          value={this.state.search_postcode}
                          onChange={this.handleSearchPostCodeChange}
                          autoComplete="off"
                        />
                        <button
                          className="fl-1 find-address-button"
                          onClick={this.checkTelephoneNumber}
                          disabled={!this.state.postcode_valid}
                          data-testid={
                            this.props.signed_in === false
                              ? 'guest-find-address'
                              : 'account-find-address'
                          }>
                          {this.state.loading ? loading : 'Find Address'}
                        </button>
                        <div className="manual-select-wrapper">
                          {this.state.showManualAddressButton &&
                            !postcodeExcluded && (
                              <button
                                className="manual-select"
                                onClick={() =>
                                  this.setState({ showManualAddressForm: true })
                                }>
                                Enter Address Manually
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {postcodeSearchError}
                </div>
              )}
            </div>

            {this.state.addresses.length > 0 && (
              <div>
                <div className="available--addresses">
                  <ul>
                    {this.state.addresses.map((address, index) => {
                      let className =
                        this.state.selected === address ? 'active' : 'inactive';
                      return (
                        <li
                          key={index}
                          className={className}
                          onClick={() => {
                            this.setGuestDeliveryAddress(address);
                          }}>
                          {address.short_name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}
            {this.state.showManualAddressForm && (
              <ManualAddressForm
                handleAddressLine1Change={this.globalHandleInputChange}
                handleAddressLine2Change={this.globalHandleInputChange}
                handleAddressLine3Change={this.globalHandleInputChange}
                handleAddressLine4Change={this.globalHandleInputChange}
                handlePostCodeChange={this.globalHandleInputChange}
                line1={this.state.selectedAddress.line_1}
                line2={this.state.selectedAddress.line_2}
                line3={this.state.selectedAddress.line_3}
                line4={this.state.selectedAddress.line_4}
                postcode={this.state.selectedAddress.postcode}
              />
            )}
            <div className=" fl-on fl-sm-on fl-jc-fs fl-sm-jc-fs ">
              {this.state.showManualAddressForm && (
                <button
                  ref={this.deliveryScrollRef}
                  disabled={!this.state.newAddressValid}
                  onClick={this.handleGuestDeliveryAddress}
                  className="next-panel">
                  Continue to Delivery Details
                </button>
              )}
            </div>
          </div>
        )}

        {this.props.signed_in === true && (
          <div>
            {choose}
            <DeliverToBranch
              branchAddress={this.props.branchAddress}
              addresses={this.props.branches}
              showBranchPanel={this.props.showBranchPanel}
              showNoBranches={this.props.showNoBranches}
              addressMode={this.props.addressMode}
              getBranches={this.props.getBranches}
              setAddressFromAddressBook={this.props.setAddressFromAddressBook}
              selectedDeliveryAddress={this.props.selectedDeliveryAddress}
              setBranchAddressFlag={this.props.setBranchAddressFlag}
              valid_postcode={this.valid_postcode}
              signed_in={this.props.signed_in}
            />
          </div>
        )}

        {this.props.signed_in === true && (
          <AddressBook
            addresses={this.props.addressBook}
            addressMode={this.props.addressMode}
            setAddressFromAddressBook={this.props.setAddressFromAddressBook}
            selectedDeliveryAddress={this.props.selectedDeliveryAddress}
          />
        )}

        {this.props.signed_in === true && (
          <NewAddress
            addressMode={this.props.addressMode}
            addressEnquiryUrl={this.props.addressEnquiryUrl}
            deliveryAddressUrl={this.props.deliveryAddressUrl}
            getAddressBook={this.props.getAddressBook}
            setAddressFromAddressBook={this.props.setAddressFromAddressBook}
            setAddressMode={this.props.setAddressMode}
            signed_in={this.props.signed_in}
            configGenericError={this.props.configGenericError}
            toggleGenericError={this.props.toggleGenericError}
            handleSignedInpostcodeError={this.handleSignedInpostcodeError}
            showManualAddressForm={this.state.signedInpostcodeError}
            telephone={this.state.telephone}
            current_step={this.props.current_step}
          />
        )}

        {this.props.signed_in &&
          this.props.addressMode === 'INVOICE_ADDRESS' && (
            <div className="checkout-sub-panel fl-on fl-sm-on next-step">
              {nextStep}
            </div>
          )}
      </div>
    );
  }
}

export default DeliveryAddress;
